(function(){
  var I = window.__plBotI18n;
  if(!I) return;
  var WORKER_URL = '/apps/assistant';
  var SF_TOKEN = '89f6aa585539e0e8441ff125fc7edfc1';
  var SF_EP = 'https://cuisine-and-patisserie.myshopify.com/api/2026-07/graphql.json';
  var TS_SITEKEY = '0x4AAAAAAFOHQg39sbjOdZm5'; // Managed Turnstile; verified by the signed proxy.
  var LANG = window.__plBotLanguage;
  var convo = [];
  var pending = null;
  var pairReco = null;
  var lastCart = [];
  var SID = null;
  try{ SID = sessionStorage.getItem('plb_sid') || null; }catch(e){}
  var MENU = ['commande','livraison','remises','facture','trouver','conseil','photo'];
  function esc(s){ var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

  // Textes du module photo, 8 langues, integres au snippet
  var PH = ({
    fr:{busy:"Beaucoup de demandes en ce moment. Patientez une minute puis réessayez, votre photo sera bien analysée.", chip:"Photo d'un gâteau", intro:"Nouveau : envoyez la photo d'un gâteau qui vous inspire, j'identifie la technique et je vous liste le matériel exact pour le réaliser.", tz:"Envoyez la photo d'un gâteau, on vous liste le matériel", btn:'Envoyer une photo de gateau', d:'Voici une photo, proposez le materiel pour realiser cela.', err:'Cette image est trop lourde ou illisible, essayez une autre photo.'},
    en:{busy:"A lot of requests right now. Wait a minute and try again, your photo will be analysed.", chip:"Photo of a cake", intro:"New: send a photo of a cake that inspires you, I identify the technique and list the exact equipment to make it.", tz:"Send a photo of a cake, we list the equipment for you", btn:'Send a cake photo', d:'Here is a photo, suggest the equipment to make this.', err:'This image is too large or unreadable, please try another photo.'},
    de:{busy:"Gerade viele Anfragen. Warten Sie eine Minute und versuchen Sie es erneut, Ihr Foto wird analysiert.", chip:"Foto einer Torte", intro:"Neu: Senden Sie das Foto einer Torte, die Sie inspiriert. Ich erkenne die Technik und liste das genaue Material auf.", tz:"Senden Sie ein Tortenfoto, wir listen das Material auf", btn:'Ein Tortenfoto senden', d:'Hier ist ein Foto, schlagen Sie das Material vor, um das zu machen.', err:'Dieses Bild ist zu gross oder unlesbar, bitte versuchen Sie ein anderes Foto.'},
    es:{busy:"Muchas solicitudes en este momento. Espere un minuto y vuelva a intentarlo, su foto será analizada.", chip:"Foto de una tarta", intro:"Nuevo: envíe la foto de una tarta que le inspire, identifico la técnica y le doy la lista exacta del material.", tz:"Envíe la foto de una tarta y le damos la lista del material", btn:'Enviar una foto de tarta', d:'Aqui tiene una foto, proponga el material para hacerlo.', err:'Esta imagen es demasiado pesada o ilegible, pruebe con otra foto.'},
    it:{busy:"Molte richieste in questo momento. Attendi un minuto e riprova, la tua foto sarà analizzata.", chip:"Foto di una torta", intro:"Novità: invia la foto di una torta che ti ispira, identifico la tecnica e ti elenco il materiale esatto per realizzarla.", tz:"Invia la foto di una torta, ti elenchiamo il materiale", btn:'Invia una foto di torta', d:'Ecco una foto, proponi il materiale per realizzarla.', err:'Questa immagine e troppo pesante o illeggibile, prova un altra foto.'},
    nl:{busy:"Veel aanvragen op dit moment. Wacht een minuut en probeer opnieuw, je foto wordt geanalyseerd.", chip:"Foto van een taart", intro:"Nieuw: stuur de foto van een taart die je inspireert, ik herken de techniek en geef je de exacte materiaallijst.", tz:"Stuur een taartfoto, wij geven je de materiaallijst", btn:'Stuur een taartfoto', d:'Hier is een foto, stel het materiaal voor om dit te maken.', err:'Deze afbeelding is te groot of onleesbaar, probeer een andere foto.'},
    pl:{busy:"Dużo zapytań w tej chwili. Poczekaj minutę i spróbuj ponownie, Twoje zdjęcie zostanie przeanalizowane.", chip:"Zdjęcie tortu", intro:"Nowość: wyślij zdjęcie tortu, który Cię inspiruje. Rozpoznam technikę i podam dokładną listę materiałów.", tz:"Wyślij zdjęcie tortu, podamy Ci listę materiałów", btn:'Wyslij zdjecie tortu', d:'Oto zdjecie, zaproponuj material do wykonania tego.', err:'Ten obraz jest zbyt duzy lub nieczytelny, sprobuj innego zdjecia.'},
    pt:{busy:"Muitos pedidos neste momento. Aguarde um minuto e tente novamente, a sua foto será analisada.", chip:"Foto de um bolo", intro:"Novidade: envie a foto de um bolo que o inspire, identifico a técnica e listo o material exato para o fazer.", tz:"Envie a foto de um bolo, damos-lhe a lista do material", btn:'Enviar uma foto de bolo', d:'Aqui esta uma foto, proponha o material para fazer isto.', err:'Esta imagem e demasiado pesada ou ilegivel, tente outra foto.'}
  })[LANG] || {busy:'A lot of requests right now. Wait a minute and try again, your photo will be analysed.', chip:'Photo of a cake', intro:'New: send a photo of a cake that inspires you, I identify the technique and list the exact equipment to make it.', tz:'Send a photo of a cake, we list the equipment for you', btn:'Send a cake photo', d:'Here is a photo, suggest the equipment to make this.', err:'This image is too large or unreadable, please try another photo.'};

  var ANSWERS = {
    bonjour: {p:[I.A.bj, esc(PH.intro)], c:MENU},
    livraison: {p:[I.A.l1, I.A.l2], c:['commande','remises']},
    relais: {p:[I.A.rel], c:['livraison','commande']},
    retours: {p:[I.A.r1, I.A.r2], c:['commande']},
    magasin: {p:[I.A.m1, I.A.m2], c:['livraison']},
    chaleur: {p:[I.A.c1, I.A.c2], c:['livraison']},
    contact: {p:[I.A.ct], c:['commande','livraison']},
    telephone: {p:[I.A.tel], c:['commande','autre']},
    facture: {p:[I.A.fa1, I.A.fa2], c:['commande','autre']},
    merci: {p:[I.A.mc], c:[]},
    fallback: {p:[I.A.fb], c:MENU}
  };

  function ordersAnswer(){
    var o = window.__plBotOrders;
    if(!o){ return {p:[I.O.g1, I.O.g2], c:['livraison']}; }
    if(!o.length){ return {p:[I.O.no], c:['livraison','remises']}; }
    var html = I.O.in + '<br>';
    for(var i=0;i < o.length;i++){
      html += '<a href="'+o[i].url+'" target="_blank" rel="noopener">'+o[i].name+'</a> '+I.O.du+' '+o[i].date+' : '+o[i].paiement+', '+o[i].expedition+'<br>';
    }
    html += I.O.out;
    return {p:[html], c:['livraison']};
  }

  function remisesAnswer(){
    var o = window.__plBotOrders;
    if(o && o.length){ return {p:[I.R.h1, I.R.h2], c:['commande','autre']}; }
    if(o){ return {p:[I.R.n1, I.R.n2], c:['commande','autre']}; }
    return {p:[I.R.v1, I.R.v2], c:['commande','autre']};
  }

  function produitsFallback(raw){
    return {p:[I.P.p1+' <a href="/search?q='+encodeURIComponent(raw)+'" target="_blank" rel="noopener">'+I.P.l1+'</a>.', I.P.p2], c:['autre']};
  }

  var INTENTS = [
    {id:'facture', k:['factur','invoice','rechnung','fattura','factuur','fatura','receipt']},
    {id:'telephone', k:['telephone','numero de telephone','appeler','appel','phone','telefon','telefono','telefoon','bellen','llamar','chiamare','ligar','call']},
    {id:'relais', k:['relais','domicile','pickup','paketshop','punto de recogida','punto di ritiro','afhaalpunt','recolha','abholstation']},
    {id:'chaleur', k:['chaleur','fondu','ramolli','canicule','melt','geschmolzen','hitze','derretid','sciolto','gesmolten','warmte']},
    {id:'commande', k:['commande','suivi','suivre','colis','expedi','numero','track','ou est','order','bestellung','sendung','pedido','ordine','spedizione','encomenda','bestelling','pakket','parcel','where is','rastre']},
    {id:'retours', k:['retour','rembours','retract','echang','annul','return','refund','ruckgabe','erstattung','devoluc','reembolso','rimborso','terugbetaling','widerruf']},
    {id:'magasin', k:['magasin','osny','retrait','click','collect','horaire','boutique','adresse','waze','maps','itineraire','venir','acces','gps','store','laden','tienda','negozio','loja','winkel','anfahrt','directions']},
    {id:'remises', k:['remise','promo','code','reduc','recompense','fidel','geste','offre','discount','coupon','voucher','rabatt','gutschein','descuento','sconto','desconto','korting']},
    {id:'contact', k:['humain','conseiller','equipe','parler','email','mail','joindre','reclamation','sav','probleme','human','team','mensch','mitarbeiter','humano','equipo','umano','klacht','reclamac','reclamo','complaint','agent']},
    {id:'livraison', k:['livraison','delai','expedition','frais de port','transport','gls','envoi','delivery','shipping','versand','lieferung','entrega','envio','consegna','bezorg','verzend','portes','levertijd','plazo','schicken','verschicken','spedire','enviar','wysylka','porto']},
    {id:'merci', k:['merci','parfait','super','top','thank','danke','gracias','grazie','obrigad','bedankt','dank']},
    {id:'bonjour', k:['bonjour','bonsoir','salut','coucou','hello','hallo','hola','ciao','goedendag','guten']}
  ];

  function norm(s){ return s.toLowerCase().replace(/œ/g,'oe').replace(/æ/g,'ae').normalize('NFD').replace(/[̀-ͯ]/g,''); }
  function normP(s){ return norm(s).replace(/[^a-z0-9\s#]/g,' ').replace(/\s+/g,' '); }

  var msgs = document.getElementById('pl-bot-msgs');
  var chipsBox = document.getElementById('pl-bot-chips');
  var panel = document.getElementById('pl-bot-panel');
  var input = document.getElementById('pl-bot-input');
  var teaser = document.getElementById('pl-bot-teaser');
  var photoInput = document.getElementById('pl-bot-photo');
  var photoBtn = document.getElementById('pl-bot-photo-btn');

  document.getElementById('pl-bot-sub').textContent = I.sub;
  document.getElementById('pl-bot-teaser-txt').textContent = I.G.tz;
  input.placeholder = I.ph;
  input.setAttribute('aria-label', I.inp);
  document.getElementById('pl-bot-launcher').setAttribute('aria-label', I.open);
  document.getElementById('pl-bot-close').setAttribute('aria-label', I.close);
  document.getElementById('pl-bot-send').setAttribute('aria-label', I.send);
  photoBtn.setAttribute('aria-label', PH.btn);
  photoBtn.title = PH.btn;

  function scroll(){ msgs.scrollTop = msgs.scrollHeight; }

  function bot(html){
    var d = document.createElement('div');
    d.className = 'plb-m plb-bot';
    d.innerHTML = html;
    msgs.appendChild(d); scroll();
  }

  function user(text){
    var d = document.createElement('div');
    d.className = 'plb-m plb-user';
    d.textContent = text;
    msgs.appendChild(d); scroll();
  }

  function userImg(dataUrl){
    var d = document.createElement('div');
    d.className = 'plb-m plb-user';
    var im = document.createElement('img');
    im.className = 'plb-img';
    im.src = dataUrl;
    im.alt = '';
    d.appendChild(im);
    msgs.appendChild(d); scroll();
  }

  function typing(){
    var d = document.createElement('div');
    d.className = 'plb-m plb-bot plb-typing';
    d.innerHTML = '<i></i><i></i><i></i>';
    msgs.appendChild(d); scroll();
    return d;
  }

  function chips(keys){
    chipsBox.innerHTML = '';
    (keys||[]).forEach(function(key){
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'plb-chip'; b.textContent = (key === 'photo') ? PH.chip : (I.L[key] || key);
      b.addEventListener('click', function(){ dispatch(key); });
      chipsBox.appendChild(b);
    });
  }

  function stripHtml(h){ var d = document.createElement('div'); d.innerHTML = h; return d.textContent || ''; }
  function say(a){
    chips([]);
    try{
      convo.push({role:'assistant', content: a.p.map(stripHtml).join(' ').slice(0, 500)});
      if(convo.length > 12) convo = convo.slice(-12);
    }catch(e){}
    var i = 0;
    function next(){
      if(i >= a.p.length){ chips(a.c || []); return; }
      var tp = typing();
      var d = Math.min(600 + a.p[i].length * 7, 1700);
      setTimeout(function(){ tp.remove(); bot(a.p[i]); i++; next(); }, d);
    }
    next();
  }

  function bareLinkify(s){
    return s.replace(/(https?:\/\/[^\s<]+)/g, function(u){
      var clean = u.replace(/[.,;:)!?]+$/, '');
      var trail = u.slice(clean.length);
      var label = clean.replace(/^https?:\/\//, '').replace(/^www\./, '');
      if(label.length > 48) label = label.slice(0, 45) + '...';
      return '<a href="' + clean + '" target="_blank" rel="noopener">' + label + '</a>' + trail;
    });
  }
  // Rendu leger des reponses IA : liens markdown, gras, URL nues, sauts de ligne
  function mdRender(s){
    var h = esc(s);
    h = h.replace(/\[([^\]\n]{1,90})\]\((https?:\/\/[^\s)]+)\)/g, function(m, t, u){ return '<a href="' + u + '" target="_blank" rel="noopener">' + t + '</a>'; });
    h = h.replace(/\*\*([^*\n]{1,140})\*\*/g, '<b>$1</b>');
    h = h.split(/(<a [^>]*>[^<]*<\/a>)/g).map(function(part){
      return part.indexOf('<a ') === 0 ? part : bareLinkify(part);
    }).join('');
    return h.replace(/\n/g, '<br>');
  }

  function renderSources(list){
    if(!list || !list.length) return;
    var wrap = document.createElement('div');
    wrap.className = 'plb-srcs';
    for(var i=0;i < list.length && wrap.children.length<6;i++){
      var s = list[i];
      if(!s || !s.url || !s.titre) continue;
      if(!/^https:\/\/(www\.)?patissland\.fr\//.test(s.url) && !/^https:\/\/cuisine-and-patisserie\.myshopify\.com\//.test(s.url)) continue;
      // Bloque tout lien d'ajout direct au panier propose par l IA (permalien panier
      // /cart/VARIANT:QTY, /cart/add, etc.) : un clic ne doit jamais ajouter au panier
      // sans passer par la fiche produit, meme si le Worker suggere ce type d URL.
      if(/\/cart(\/|\?|$)/i.test(s.url)) continue;
      var a = document.createElement('a');
      a.className = 'plb-src';
      a.href = s.url;
      a.target = '_blank';
      a.rel = 'noopener';
      var t = document.createElement('span');
      t.className = 'plb-src-t';
      t.textContent = s.titre;
      var r = document.createElement('span');
      r.className = 'plb-src-r';
      r.textContent = (s.prix && s.prix.indexOf('€') > -1) ? s.prix : '›';
      a.appendChild(t); a.appendChild(r);
      wrap.appendChild(a);
    }
    if(wrap.children.length){ msgs.appendChild(wrap); scroll(); }
  }

  // ---- Turnstile (actif uniquement si TS_SITEKEY est renseigne ; widget de type Invisible) ----
  var tsWidget=null,tsWaiters=[],tsLoading=null,tsBusy=false;
function tsLoad(cb){
  if(window.turnstile){cb();return}
  if(!tsLoading)tsLoading=new Promise(function(resolve){
    var sc=document.createElement('script');
    sc.src='https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    sc.async=true;sc.onload=resolve;sc.onerror=function(){tsLoading=null;resolve()};
    document.head.appendChild(sc);
  });
  tsLoading.then(cb);
}
function tsComplete(token){
  if(!tsBusy)return;
  tsBusy=false;
  var waiter=tsWaiters.shift();
  if(waiter){clearTimeout(waiter.timer);waiter.resolve(token)}
  if(tsWaiters.length)setTimeout(tsPump,0);
}
function tsInit(){
  if(tsWidget!==null||!window.turnstile)return;
  var mount=document.getElementById('pl-bot-turnstile');
  if(!mount){
    mount=document.createElement('div');mount.id='pl-bot-turnstile';
    mount.style.cssText='padding:4px 12px;max-width:100%;overflow:hidden';
    var form=document.getElementById('pl-bot-form');
    if(!form||!form.parentNode)return;
    form.parentNode.insertBefore(mount,form);
  }
  try{tsWidget=window.turnstile.render(mount,{
    sitekey:TS_SITEKEY,action:'assistant',execution:'execute',appearance:'interaction-only',size:'flexible',
    retry:'never','refresh-expired':'manual',
    callback:function(token){tsComplete(token)},
    'error-callback':function(){tsComplete(null)},
    'expired-callback':function(){tsComplete(null)},
    'timeout-callback':function(){tsComplete(null)}
  })}catch(e){tsWidget=null}
}
function tsPump(){
  if(tsBusy||!tsWaiters.length)return;
  tsInit();tsBusy=true;
  if(!window.turnstile||tsWidget===null){tsComplete(null);return}
  var waiter=tsWaiters[0];
  waiter.timer=setTimeout(function(){
    if(tsWaiters[0]!==waiter)return;
    try{window.turnstile.reset(tsWidget)}catch(e){}
    tsComplete(null);
  },60000);
  try{window.turnstile.reset(tsWidget);window.turnstile.execute(tsWidget)}catch(e){tsComplete(null)}
}
function tsGet(){
  return new Promise(function(resolve){
    tsLoad(function(){tsWaiters.push({resolve:resolve,timer:null});tsPump()});
  });
}

  function askAI(sendText, raw, image){
    chips([]);
    var tp = typing();
    tsGet().then(function(token){
      if(!token){
        tp.remove();
        bot(esc(LANG === 'fr' ? 'La vérification anti-robot n’a pas abouti. Réessayez votre message.' : 'The security check did not complete. Please send your message again.'));
        return;
      }
      var ctrl = ('AbortController' in window) ? new AbortController() : null;
      var to = setTimeout(function(){ if(ctrl) ctrl.abort(); }, image ? 90000 : 45000); // vision = analyse + outils, plus long
      var payload = {
        message: sendText,
        lang: LANG,
        sessionId: SID,
        turnstile: token,
        page: window.__plBotPage || null,
        cart: lastCart,
        history: convo.slice(-6)
      };
      if(image){ payload.image = image; }
      fetch(WORKER_URL, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(payload),
        signal: ctrl ? ctrl.signal : undefined
      }).then(function(r){ return r.json(); }).then(function(d){
        clearTimeout(to); tp.remove();
        if(d && d.sessionId){ SID = d.sessionId; try{ sessionStorage.setItem('plb_sid', d.sessionId); }catch(e){} }
        var txt = (d && d.reply) ? String(d.reply) : '';
        if(!txt){
          if(d && d.erreur){ bot(esc(PH.busy)); chips(['autre']); return; } // rate limit ou erreur serveur explicite
          say(produitsFallback(raw)); return;
        }
        bot(mdRender(txt));
        renderSources(d ? d.sources : null);
        convo.push({role:'assistant', content: txt});
        if(convo.length > 12) convo = convo.slice(-12);
      }).catch(function(){
        clearTimeout(to); tp.remove();
        say(produitsFallback(raw));
      });
    });
  }

  function dispatch(key){
    if(key === 'photo'){ user(PH.chip); photoInput.click(); return; }
    user(I.L[key] || key);
    pending = null;
    if(key === 'commande'){ say(ordersAnswer()); return; }
    if(key === 'remises'){ say(remisesAnswer()); return; }
    if(key === 'trouver'){ pending = 'produit'; say({p:[I.K.tr], c:[]}); return; }
    if(key === 'conseil'){ pending = 'conseil'; say({p:[I.K.co], c:[]}); return; }
    if(key === 'autre'){ say({p:[I.K.au], c:MENU}); return; }
    if(ANSWERS[key]){ say(ANSWERS[key]); return; }
    say(ANSWERS.fallback);
  }

  function handleText(raw){
    convo.push({role:'user', content: raw});
    if(convo.length > 12) convo = convo.slice(-12);
    var t = norm(raw);

    if(pending){
      var mode = pending; pending = null;
      askAI((mode === 'conseil' ? 'Le client demande un conseil d’utilisation : ' : 'Le client cherche un produit : ') + raw, raw);
      return;
    }

    var best = null, bs = 0;
    function kwHit(txt, k){
      var esc = k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      return new RegExp('(^|[^a-z0-9])' + esc).test(txt); // frontiere gauche : recommande ne matche plus commande
    }
    if (/(^|[^a-z0-9])(stock|reappro|disponib|restock|availability)/.test(t) || INTENTS.some(function(it){
      return it.id === 'retours' && it.k.some(function(k){ return kwHit(t, k); });
    })) { askAI(raw, raw); return; }
    INTENTS.forEach(function(it){
      var s = 0;
      it.k.forEach(function(k){ if(kwHit(t, k)) s++; });
      if(s > bs){ bs = s; best = it.id; }
    });
    if(!best){ askAI(raw, raw); return; }
    if(best === 'commande'){ say(ordersAnswer()); return; }
    if(best === 'remises'){ say(remisesAnswer()); return; }
    say(ANSWERS[best] || ANSWERS.fallback);
  }

  // ---- Module photo : compression canvas puis envoi vision au worker ----
  function sendPhoto(file){
    if(!file || !/^image\/(jpeg|png|webp)$/.test(file.type)){ bot(esc(PH.err)); return; }
    var fr = new FileReader();
    fr.onerror = function(){ bot(esc(PH.err)); };
    fr.onload = function(){
      var img = new Image();
      img.onerror = function(){ bot(esc(PH.err)); };
      img.onload = function(){
        function pack(maxSide, quality){
          var w = img.width, h = img.height;
          var sc = Math.min(1, maxSide / Math.max(w, h));
          var cv = document.createElement('canvas');
          cv.width = Math.max(1, Math.round(w * sc));
          cv.height = Math.max(1, Math.round(h * sc));
          cv.getContext('2d').drawImage(img, 0, 0, cv.width, cv.height);
          return cv.toDataURL('image/jpeg', quality);
        }
        var dataUrl = pack(1024, 0.85);
        if(dataUrl.length > 1900000) dataUrl = pack(800, 0.7);
        if(dataUrl.length > 1900000){ bot(esc(PH.err)); return; }
        var b64 = dataUrl.split(',')[1];
        userImg(dataUrl);
        var txt = input.value.trim();
        input.value = '';
        if(txt) user(txt);
        convo.push({role:'user', content: txt || '[photo]'});
        if(convo.length > 12) convo = convo.slice(-12);
        askAI(txt || PH.d, txt || 'photo', {media_type:'image/jpeg', data:b64});
      };
      img.src = fr.result;
    };
    fr.readAsDataURL(file);
  }

  photoBtn.addEventListener('click', function(){ photoInput.click(); });
  photoInput.addEventListener('change', function(){
    var f = photoInput.files && photoInput.files[0];
    photoInput.value = '';
    if(f) sendPhoto(f);
  });

  // ---- Module paires indispensables (analyse ventes 12 mois, aucune tablette) ----
  var RULES = [
    {trig:/trompe l ?oeil (framboise|fraise)/, abs:/spray|velours/, q:['spray velours rouge','inspiration framboise']},
    {trig:/trompe l ?oeil (citron|mangue)/, abs:/spray|velours/, q:['spray velours jaune','inspiration yuzu']},
    {trig:/trompe l ?oeil pistache/, abs:/spray|velours/, q:['spray velours vert']},
    {trig:/trompe l ?oeil/, abs:/spray|velours/, q:['spray velours','moule trompe l oeil']},
    {trig:/moule.*(buche|entremets)|kit.*buche/, abs:/spray|velours/, q:['spray velours']},
    {trig:/spray|velours/, abs:/gelatine/, q:['gelatine 200 bloom','feuille d or 24k']},
    {trig:/plateau traiteur/, abs:/boite.*plateau/, q:['boite plateaux traiteur']},
    {trig:/cake dummy|dummy rond/, abs:/drum|support|semelle/, q:['cake drum rond']},
    {trig:/douille fleurs #?104/, abs:/125/, q:['douille fleurs 125']},
    {trig:/douille fleurs #?125/, abs:/104/, q:['douille fleurs 104']},
    {trig:/moule rond haut/, abs:/drum|support|semelle/, q:['cake drum rond','boite a gateau layer']},
    {trig:/pate a sucre/, abs:/boite|semelle|drum|support/, q:['boite a gateau layer cake','outils de modelage']},
    {trig:/boite a gateau|boite a layer/, abs:/semelle|drum|support/, q:['semelle a gateau']},
    {trig:/semelle|cake drum|support a gateau/, abs:/boite a gateau|boite a layer/, q:['boite a gateau layer cake']}
  ];

  function sfFind(q){
    return fetch(SF_EP, {
      method:'POST',
      headers:{'Content-Type':'application/json','X-Shopify-Storefront-Access-Token':SF_TOKEN},
      body: JSON.stringify({query:'query($q:String!){search(query:$q,first:3,types:[PRODUCT]){nodes{... on Product{title handle availableForSale priceRange{minVariantPrice{amount}}}}}}',variables:{q:q}})
    }).then(function(r){return r.json();}).then(function(d){return ((d.data||{}).search||{}).nodes||[];}).catch(function(){return [];});
  }

  function showTeaser(){ if(!panel.classList.contains('plb-open')) teaser.classList.add('plb-on'); }
  function hideTeaser(){ teaser.classList.remove('plb-on'); }

  function checkPairs(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
      var items = c.items || [];
      lastCart = items.slice(0, 5).map(function(it){
        return { titre: it.product_title || it.title || '', qte: it.quantity || 1 };
      });
      try{ if(sessionStorage.getItem('plb_pair') === '1') return; }catch(e){}
      if(pairReco) return;
      if(!items.length) return;
      var normed = items.map(function(it){ return normP(it.product_title || it.title || ''); });
      var joined = ' | ' + normed.join(' | ') + ' ';
      for(var i=0;i < RULES.length;i++){
        var r = RULES[i], hit = null;
        for(var j=0;j < normed.length;j++){ if(r.trig.test(normed[j])){ hit = items[j].product_title || items[j].title; break; } }
        if(hit && !r.abs.test(joined)){
          pairReco = { p: hit, q: r.q, handles: items.map(function(it){ return it.handle; }) };
          showTeaser();
          return;
        }
      }
    }).catch(function(){});
  }

  function recoFlow(){
    if(!pairReco) return;
    var reco = pairReco;
    var tp = typing();
    Promise.all(reco.q.map(sfFind)).then(function(lists){
      var lines = [], seen = {};
      lists.forEach(function(nodes){
        for(var i=0;i < nodes.length;i++){
          var p = nodes[i];
          if(!p.availableForSale) continue;
          if(reco.handles.indexOf(p.handle) > -1) continue;
          if(seen[p.handle]) continue;
          seen[p.handle] = 1;
          var prix = parseFloat(p.priceRange.minVariantPrice.amount).toFixed(2).replace('.', ',') + ' €';
          lines.push('<a href="/products/'+p.handle+'" target="_blank" rel="noopener">'+esc(p.title)+'</a> · '+prix);
          break;
        }
      });
      tp.remove();
      if(!lines.length){ if(!msgs.children.length) say(ANSWERS.bonjour); return; }
      bot(I.G.pi.replace('{p}', '<b>'+esc(reco.p)+'</b>') + '<br>' + lines.join('<br>'));
      chips(['autre']);
    }).catch(function(){ tp.remove(); });
  }

  teaser.addEventListener('click', function(e){
    if(e.target && e.target.id === 'pl-bot-teaser-x'){
      try{ sessionStorage.setItem('plb_pair','1'); }catch(err){}
      hideTeaser(); return;
    }
    try{ sessionStorage.setItem('plb_pair','1'); }catch(err){}
    hideTeaser();
    panel.classList.add('plb-open');
    if(pairReco){ recoFlow(); }
    else if(!msgs.children.length){ say(ANSWERS.bonjour); input.focus(); }
  });

  // Teaser decouverte photo : une fois par session, seulement si aucune reco paire n'occupe la bulle
  setTimeout(function(){
    try{ if(sessionStorage.getItem('plb_phz') === '1') return; }catch(e){}
    if(pairReco || teaser.classList.contains('plb-on') || panel.classList.contains('plb-open')) return;
    document.getElementById('pl-bot-teaser-txt').textContent = PH.tz;
    teaser.classList.add('plb-on');
    try{ sessionStorage.setItem('plb_phz','1'); }catch(e){}
  }, 2600);

  // Pont depuis la bande page d'accueil : ouvre le bot et lance le selecteur photo
  document.addEventListener('plb:photo', function(){
    hideTeaser();
    panel.classList.add('plb-open');
    if(!msgs.children.length){ say(ANSWERS.bonjour); }
    photoInput.click();
  });

  var pairTimer = null;
  function checkPairsSoon(){ clearTimeout(pairTimer); pairTimer = setTimeout(checkPairs, 800); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', checkPairsSoon); } else { checkPairsSoon(); }
  document.addEventListener('cart:build', checkPairsSoon);
  document.addEventListener('ajaxProduct:added', checkPairsSoon);

  document.getElementById('pl-bot-launcher').addEventListener('click', function(){
    panel.classList.toggle('plb-open');
    if(panel.classList.contains('plb-open')){
      hideTeaser();
      tsLoad(function(){ tsInit(); });
      if(!msgs.children.length){ say(ANSWERS.bonjour); }
      input.focus();
    }
  });
  document.getElementById('pl-bot-close').addEventListener('click', function(){ panel.classList.remove('plb-open'); });
  document.getElementById('pl-bot-form').addEventListener('submit', function(e){
    e.preventDefault();
    var v = input.value.trim();
    if(!v) return;
    user(v); input.value = '';
    handleText(v);
  });
})();
